import React from 'react'

const Table = () => {
    return (
        <div>
            <div id="PlanningsContainer" class="bg-gray-100 hidden" >
                <div class="container mx-auto py-8">
                   

                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-darkteal">
                            <thead>
                                <tr>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Territory</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">FSO Name</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Diamond Dealer Name</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Monthly Collection</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Monthly Sales</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">FMFD</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Salary</th>
                                    <th class="px-4 py-2 border border-darkteal bg-darkteal text-white">Remarks</th>


                                </tr>
                            </thead>
                            <tbody>
                                    <tr>
                                        <td class="px-4 py-2 border border-darkteal text-center"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>
                                        <td class="px-4 py-2 border border-darkteal"></td>

                                    </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Table
